import { z } from 'zod';
import { PROFILE_VERIFIED_TYPES } from './profile-constants.js';

export const ProfileInteractionEntrySchema = z.object({
  profileId: z.string(),
  username: z.string().nullable(),
  name: z.string().nullable(),
  profileImageUrl: z.string().nullable().optional(),
  verifiedType: z.enum(PROFILE_VERIFIED_TYPES),
  replyInbound: z.number().int().nonnegative(),
  replyOutbound: z.number().int().nonnegative(),
  retweetInbound: z.number().int().nonnegative(),
  retweetOutbound: z.number().int().nonnegative(),
  mentionInbound: z.number().int().nonnegative(),
  mentionOutbound: z.number().int().nonnegative(),
  totalInbound: z.number().int().nonnegative(),
  totalOutbound: z.number().int().nonnegative(),
  totalInteractions: z.number().int().nonnegative(),
  lastInboundAt: z.date().nullable(),
  lastOutboundAt: z.date().nullable(),
});

export const ProfileInteractionsResponseSchema = z.object({
  profileId: z.string(),
  total: z.number().int().nonnegative(),
  interactions: z.array(ProfileInteractionEntrySchema),
});

export type ProfileInteractionEntry = z.infer<typeof ProfileInteractionEntrySchema>;
export type ProfileInteractionsResponse = z.infer<typeof ProfileInteractionsResponseSchema>;
